import React from "react";
import { withTranslation } from "react-i18next";

import { Button, CircularProgress, Grid } from "@mui/material";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { useFormik } from "formik";

import { usePostDemandEstimationForOtherUtilityMutation } from "apis/DemandEstimation";

import Modal from "Components/Common/Modal";
import InputFieldText from "Components/Common/InputFieldText";

import { onlyNumberKeys } from "utils";


const EnergizationDelayModal = ({ t, applicationId, handleClose }) => {
  const [addDemandEstimation, { isLoading }] =
    usePostDemandEstimationForOtherUtilityMutation();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      dcsActivationPeriod: null,
    },
    validationSchema: Yup.object({
      dcsActivationPeriod: Yup.number().nullable().required("Month is required"),
    }),
    onSubmit: async (values) => {
      try {
        await addDemandEstimation(applicationId, values);
        handleClose();
      } catch (error) {}
    },
  });  

  const { handleSubmit } = formik;

  return (
    <Modal
      isOpen
      handleClose={handleClose}
      title={t("Energization delay (in months)")}
      maxWidth="md"
    >
      <Grid container className="mt-3" columnSpacing={2}>
        <Grid item xs={12} md={4} sm={6}>
          <InputFieldText
            label={t("Enter delay in months") + "*"}
            name="dcsActivationPeriod"
            formik={formik}
            type="number"
            InputProps={{
              inputProps: { min: 0, onKeyDown: onlyNumberKeys },
            }}
            placeholder={t("Enter Month")}
          />
        </Grid>

        <Grid className="d-block ms-auto" mt={1}>
          <Button
            color="primary"
            variant="contained"
            type="submit"
            disabled={isLoading}
            onClick={handleSubmit}
          >
            Submit {isLoading && <CircularProgress size={20} />}
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

EnergizationDelayModal.propTypes = {
  applicationId: PropTypes.number,
  handleClose: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation()(EnergizationDelayModal);
